module.exports = __webpack_public_path__ + "static/media/gzqd.cd8a3a4f.webm";